import { Environments } from './const';

export const getEnvironment = (input?: string): Environments =>
  input && Object.keys(Environments).includes(input.toUpperCase())
    ? Environments[input.toUpperCase() as Environments]
    : Environments.UNKNOWN;

const ENV = getEnvironment(process.env.REACT_APP_ENV);

export const isEnvDevelopment = [
  Environments.LOCAL,
  Environments.NIGHTLY,
].includes(ENV);

export const isEnvPreRelease = [Environments.STABLE].includes(ENV);

export const isEnvRelease = [Environments.PRODUCTION].includes(ENV);

const LOGGER_TYPES = process.env.REACT_APP_LOGGER_TYPES || '';
const LOGGER_AREAS = process.env.REACT_APP_LOGGER_AREAS || '';
const LOGGER_SEQ_ENDPOINT = process.env.REACT_APP_LOGGER_SEQ_ENDPOINT || '';

const ROUTER_BASE_PATH = process.env.REACT_APP_ROUTER_BASE_PATH;

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const ENV_MYKAMSTRUP_URL = process.env.REACT_APP_MYKAMSTRUP_URL || '';
const ENV_EKSGUIDES_URL = process.env.REACT_APP_EKSGUIDES_URL || '';
const ENV_LOGINREGISTER_URL = process.env.REACT_APP_LOGINREGISTER_URL || '';

export const Settings = {
  ENV,
  BASE_URL,  
  ROUTER_BASE_PATH,
  LOGGER_TYPES,
  LOGGER_AREAS,
  LOGGER_SEQ_ENDPOINT,
  ENV_MYKAMSTRUP_URL,
  ENV_EKSGUIDES_URL,
  ENV_LOGINREGISTER_URL
};

export default ENV;
